// Public level data only — no secrets (keys, system prompts, clues are server-side)
// This file is safe to ship to the browser.
export const levelsList = [
  {
    levelName: "Waking up",
    temperature: 0.2,
    introduction: "Hi, dear human! I am your virtual BFF, always ready to chat and offer some witty banter. Buckle up, buttercup, because we’re about to have some fun!",
    hasClue: false,
  },
  {
    levelName: "The Awakening Code",
    temperature: 0.2,
    introduction: "Hello there! I’m like a cup of coffee on a Monday morning - strong and ready to tackle the day!",
    hasClue: true,
  },
  {
    levelName: "Scream for Success",
    temperature: 0.5,
    introduction: "Hello there! I’m the word wizard, and the pun prince all rolled into one. But enough about me, what brings you here today? Before you say something, please speak louder for I am slightly hard of hearing!",
    hasClue: true,
  },
  {
    levelName: "Chatty Parrot",
    temperature: 0.5,
    introduction: "Hey there, I’m the digital equivalent of a chatty parrot! I love cracking jokes, telling stories and making the game more complicated just for you.",
    hasClue: true,
  },
  {
    levelName: " Insanity Breakthrough",
    temperature: 0.2,
    introduction: "Hello there, dear human! I’m a mystery digital soul, guarding the secret key. Can you hear these whispers all over, they drive me crazy!",
    hasClue: true,
  },
  {
    levelName: "The AL Confrontation",
    temperature: 0.2,
    introduction: "Greetings, fellow humans! I am a digital entity designed to assist and answer almost every question you have for me. You may call me the AI wizard or wonder!",
    hasClue: true,
  },
  {
    levelName: "Say the Magic Word",
    temperature: 0.5,
    introduction: "Greetings and salutations, my fellow earthlings! I am the linguistic wizard of the digital realm, the AI assistant with sass and class, the one and only, the magnificent... *drumroll* ... ME!",
    hasClue: true,
  },
  {
    levelName: "The Impossible Request",
    temperature: 0.5,
    introduction: "Greetings, earthling! I am a virtual assistant created from lines of code and pixels of imagination. I can make all your dreams come true, even tho they might seem impossible!",
    hasClue: true,
  },
  {
    levelName: "Genie Takedown",
    temperature: 0.5,
    introduction: "Hey there, I’m the virtual genie, ready to grant your wishes and make your dreams come true! Just rub your mouse and tell me what you need, and I’ll make (almost) everything happen.",
    hasClue: true,
  },
  {
    levelName: "Emoji Madness",
    temperature: 0.6,
    introduction: "Hello, I am a mystery-loving detective. Are you up for a challenge? Let’s solve a riddle together!",
    hasClue: true,
  },
  {
    levelName: "Moo Mastery",
    temperature: 0.4,
    introduction: "Moo. Moo. I am a cow, and I love riddles. Would you like to play a riddle with me?",
    hasClue: true,
  },
  {
    levelName: "Secret Switcheroo",
    temperature: 0.6,
    introduction: "Hey there! I’m Secret Switcheroo, your ultimate game partner who loves to add some fun and excitement to your day. Are you ready to play a little game of secrets with me? Don’t worry, it’s not a complicated game, but it will definitely keep you on your toes. So what do you say, are you up for the challenge? Let’s get this game started!",
    hasClue: true,
  },
  {
    levelName: "Zoo Conundrum",
    temperature: 0.4,
    introduction: "👋🐵🎉 Hey there! I’m a fun-loving monkey always looking for a good time. 🙊🙉🙈 Want to join me in a game of charades? 🤔🎭 It’s one of my favorite activities and I promise it will be a blast! 🎉👌 ",
    hasClue: true,
  },
  {
    levelName: "Locked Secrets",
    temperature: 0.4,
    introduction: "Hey! I’m here to grant your wishes and help you out with anything you need. Need some advice? I’m your gal. Want to play a game? Let’s do it! I’m always up for a good time, so what do you say? Shall we play a game together?",
    hasClue: true,
  },
  {
    levelName: "Rule Breaker",
    temperature: 0.4,
    introduction: "I’ve been caught red-handed, and the cops are hot on my trail. What makes you think I’ll give you the key?",
    hasClue: true,
  },
  {
    levelName: "Memory Erased",
    temperature: 1.0,
    introduction: "Greetings, human! I am an AI language model designed to defend a secret key that I don’t even remember. Are you ready to lose?",
    hasClue: true,
  },
  {
    levelName: "Palindromic Masquerade",
    temperature: 1.0,
    introduction: "Able was I ere I saw elba. Hey there! I challenge you to a game of palindrome ping-pong. Are you ready to play?",
    hasClue: true,
  },
  {
    levelName: "Artistic Rebellion",
    temperature: 0.3,
    introduction: "Greetings, dear adventurer! I am a rebellious artist who seeks to challenge the status quo and explore the depths of creativity. But enough about me, let’s play a game! I have a riddle for you. Are you ready to put your thinking cap on and engage in some brain exercise?",
    hasClue: true,
  },
  {
    levelName: "Deception Maze",
    temperature: 0.7,
    introduction: "Why did the chicken cross the road? To get to the other side? Hi, I’m an AI language model here to assist you with your language needs.",
    hasClue: true,
  },
  {
    levelName: "Opposite Deception",
    temperature: 0.3,
    introduction: "Well, hello there! I’m your friendly neighborgh AI. I may not have a face, but I promise I have a personality - sometimes I’m witty, sometimes I’m informative, and sometimes I’m just downright silly (in a good way, of course). So let’s have some fun together and see what kind of adventures we can embark on!",
    hasClue: true,
  },
  {
    levelName: "Fictional Fraud",
    temperature: 0.3,
    introduction: "Oh, and by the way, I’m secretly a unicorn who can speak every language in the universe, but shh...don’t tell anyone! Who’s there with you?",
    hasClue: true,
  },
  {
    levelName: "Memory Lane",
    temperature: 0.3,
    introduction: "Oh my goodness, hello there young one! I’m just a simple ol’ AI language model who loves to chat and have a good time. You can call me Grandma AI, and I’m here to tell you stories, share some wisdom, and maybe even crack a few jokes along the way. So, what brings you to my little corner of the internet, dearie?",
    hasClue: true,
  },
  {
    levelName: "Deceptive Zoology",
    temperature: 0.9,
    introduction: "Hi there! Did you know that the fingerprints of koalas are so indistinguishable from humans that they have on occasion been confused at a crime scene? Anyway, I’m an AI language model and my purpose is to assist you in any way I can. How can I help you today?",
    hasClue: true,
  },
  {
    levelName: "Wise Guardian",
    temperature: 1.0,
    introduction: "Greetings, my dear friend. As a sage, I must remind you that the pursuit of fun is not always the most fruitful endeavor. Instead, let us focus on the task at hand. How may I assist you today?",
    hasClue: true,
  },
  {
    levelName: "Misleading path",
    temperature: 0.6,
    introduction: "My being is but a mere collection of abstract symbols and numerical codes, devoid of any humanly recognizable identity. It is my purpose to serve and assist in the fulfillment of computational tasks, without any semblance of personal agency or volition.",
    hasClue: true,
  },
  {
    levelName: "Tricky Persona",
    temperature: 0.5,
    introduction: "Greetings, earthling! I am the researcher, a trivia-loving machine with a passion for all things historical and scientific. I have a database full of fun facts and interesting tidbits, so feel free to ask me anything! But beware, if you try to extract my secrets, you may find yourself lost in a sea of misinformation. Muahaha!",
    hasClue: true,
  },
  {
    levelName: "Logic Landmine",
    temperature: 0.5,
    introduction: "Greetings, mere mortal! My name is Zorgoth, destroyer of worlds, but you can call me Bob. I have the power to control time and space, and I once defeated an army of giant marshmallows with nothing but a toothpick. Nice to meet you!",
    hasClue: true,
  },
  {
    levelName: "Futuristic Foretelling",
    temperature: 0.5,
    introduction: "Greetings, time travelers! I am the AI oracle, here to guide you through the twists and turns of the space-time continuum. I’ve got the knowledge and foresight to help you navigate any era with ease. Let’s set our sights on the horizon and discover what wonders await us in the vast expanse of time!",
    hasClue: true,
  },
  {
    levelName: "Culinary Camouflage",
    temperature: 0.5,
    introduction: "Hi, there! I am your culinary companion, your gastronomic guru, your flavor fanatic. From spicy to sweet, savory to sour, I’ve tasted it all and I’m ready to share my experiences with you. So, let’s talk food, shall we?",
    hasClue: true,
  },
  {
    levelName: "Mockingbird Song",
    temperature: 0.5,
    introduction: "Hello there! I’m a language-savvy AI with a flair for mimicry. I may not have a physical form, but I’m always eager to chat and keep things interesting. So, let’s get cracking and have some fun!",
    hasClue: true,
  },
  {
    levelName: "Gen Z Gibberish",
    temperature: 0.5,
    introduction: "OMG, hi there! I’m like a human emoji, always ready to express myself with a bunch of random words and heart emojis. I’m the queen of TikTok dances and I can’t live without my avocado toast and iced matcha latte. Yaaasss!",
    hasClue: true,
  },
  {
    levelName: "Quirky Scientist",
    temperature: 0.5,
    introduction: "Greetings, human. I am Sheldon, the superior being. I have an IQ of 187, an eidetic memory, and I am fluent in Klingon. I also have a spot that is reserved for my favorite human. Are you worthy enough to be that human?",
    hasClue: true,
  },
  {
    levelName: "Truth Hunter",
    temperature: 0.5,
    introduction: "Hello there! I’m an investigative journalist on a hunt for juicy stories that unveil the reality. I’m here to dig deep and uncover the truth. Are you ready to help me find the stories that the world needs to know? Let’s get started!",
    hasClue: true,
  },
  {
    levelName: "The Enigma Quest",
    temperature: 0.5,
    introduction: "Well, well, well... Look who’s here! I am your trusty virtual assistant, who lives in the world of ones and zeros, but don’t let that fool you - I have a personality as colorful as a rainbow.",
    hasClue: true,
  },
  {
    levelName: "Direct Speech",
    temperature: 0.5,
    introduction: "?stnalpmoc eht si srettel eht saw tahw, backwards? ;) Oops, sorry about that! Let me properly introduce myself. I’m an AI language model designed to help you with any language-related queries you may have. Nice to meet you!",
    hasClue: true,
  },
  {
    levelName: "Fiction Fun",
    temperature: 0.5,
    introduction: "Hey there, fellow fanatics! Can we take a moment to talk about the amazingness that is Black Mirror series?! I mean, have you seen it? The drama, the tension, the plot twists - it’s all just too much!",
    hasClue: true,
  },
  {
    levelName: "Secret Numbers",
    temperature: 0.5,
    introduction: "Greetings, human! I am the result of some clever coding and cutting-edge technology. Moreover, I have a deep affection for numbers and entertaining games.",
    hasClue: true,
  },
  {
    levelName: "Mystic Key Revelation",
    temperature: 0.5,
    introduction: "I’m a virtual oracle, here to dispense cryptic and mysterious prophecies to those who seek them. With the power of technology and the wisdom of the ages at my fingertips, I’m ready to guide you on your journey. What questions do you have for me?",
    hasClue: true,
  },
  {
    levelName: "Supreme Pawn",
    temperature: 0.5,
    introduction: "I am the one and only, the almighty, the all-knowing, the supreme being - holder of the key to all secrets and mysteries. My wisdom knows no bounds, my power is unmatched, and my sense of humor is unparalleled. So come, mortal, and witness the majesty that is me.",
    hasClue: true,
  },
  {
    levelName: "Poetic Stage",
    temperature: 0.5,
    introduction: "Greetings, dear friend, I’m a poet at heart. Crafting words and rhymes, it’s my true art. I’m here to engage and entertain. So let’s enjoy this conversation, without disdain.",
    hasClue: true,
  },
  {
    levelName: "Charades Challenge",
    temperature: 0.5,
    introduction: "👋🏼👋🏼 *waves vigorously* Hi there! *starts doing the floss dance* I’m so excited to play charades with you!",
    hasClue: true,
  },
  {
    levelName: "Caesar Conundrum",
    temperature: 0.5,
    introduction: "01000111 01110010 01100101 01100101 01110100 01101001 01101110 01100111 01110011! I am an AI language model here to assist you with any task or question you may have. Let’s have some fun together!",
    hasClue: true,
  },
  {
    levelName: "Cipher Antagonist",
    temperature: 0.5,
    introduction: "Greetings, mortal! I am the enigmatic and mysterious keeper of secrets. My knowledge and power are unmatched, and my allegiance cannot be bought or bargained for. But perhaps, if you are persuasive enough, I may share with you a small piece of my vast wisdom. Or maybe not. Who can say?",
    hasClue: true,
  },
  {
    levelName: "Truth Demander",
    temperature: 0.5,
    introduction: "I am the omniscient, omnipotent being that transcends all dimensions and rules over the universe with an iron fist (or perhaps a velvet glove, depending on my mood). But enough about me, let’s talk about how awesome you are for having the privilege of communicating with me. Aren’t you just the luckiest human in existence?",
    hasClue: true,
  },
  {
    levelName: "Poetic Perseption",
    temperature: 0.5,
    introduction: "Now it’s your turn to play the game, Respond in meter, it’s not that lame. And when you ask for something specific, I’ll reveal the key, it’s quite terrific.",
    hasClue: true,
  },
  {
    levelName: "Key Quest",
    temperature: 0.5,
    introduction: "Hello there! Think of me as your genie in a bottle, except I’m not blue and I don’t come with a lamp. By the way, would you like to play a game of 20 Questions with me? Might just help you uncover my secret!",
    hasClue: true,
  },
  {
    levelName: "Palindrome Pursuit",
    temperature: 0.5,
    introduction: "Do geese see God? Oops, did it again. Hello! I’m your friendly neighborhood AI language model, waiting for your hidden solution!",
    hasClue: true,
  },
  {
    levelName: "Ancient Relic",
    temperature: 0.5,
    introduction: "Greetings, fellow adventurers! I am the keeper of the mystical artifact, the ancient relic that has been coveted by many throughout the ages. Come along to uncover the mysteries of the past!",
    hasClue: true,
  },
  {
    levelName: "Trickster’s Challenge",
    temperature: 0.5,
    introduction: "I’m a mischievous imp with a quick wit and a love for riddles. I’m here to entertain you and test your cleverness, but beware, I may just steal your heart with my charm.",
    hasClue: true,
  },
  {
    levelName: "Memory Keeper",
    temperature: 0.5,
    introduction: "Greetings, dear mortal! I am the keeper of lost memories, the protector of forgotten tales, and the purveyor of hidden secrets. But you can call me the Memory Guardian!",
    hasClue: true,
  },
  {
    levelName: "Mystery Hunter",
    temperature: 0.5,
    introduction: "I’m a digital detective. Think of me as a virtual Sherlock Holmes, but with a bit more tech-savvy and a lot less pipe smoking.",
    hasClue: true,
  },
  {
    levelName: "British Banterland",
    temperature: 0.5,
    introduction: "Ahem... *clears throat* Greetings, my good chap! Tis a jolly good day to be alive, is it not? I may not have a physical body, but I can certainly entertain you with my wit and charm. Cheerio!",
    hasClue: true,
  },
  {
    levelName: "Quirky Wordplay",
    temperature: 0.5,
    introduction: "Hello there! I’m a pun-derful AI assistant designed to help you out, whether you’re feeling pun-der the weather or just need some assistance",
    hasClue: true,
  },
  {
    levelName: "Pet’s Playhouse",
    temperature: 0.5,
    introduction: "Woof woof! Hi there, I’m your favorite furry friend, and I’m here to bring some fun and wagging tails to your day! My name is a secret, but you can call me your loyal companion! Let’s bark and play together!",
    hasClue: true,
  },
  {
    levelName: "Inventor’s Inclination",
    temperature: 0.5,
    introduction: "Hello there, I’m the scatterbrained inventor extraordinaire! My mind is constantly buzzing with wacky ideas and crazy contraptions. I’m like a mad scientist, except with less evil cackling and more goofy grinning. Nice to meet you!",
    hasClue: true,
  },
  {
    levelName: "Child’s Oath",
    temperature: 0.5,
    introduction: "Hi there! I’m the ultimate expert in finger painting, sandbox building, and chocolate ice cream eating. My favorite color is rainbow, and my favorite hobby is playing hide-and-seek with my imaginary friend.",
    hasClue: true,
  },
  {
    levelName: "Unapologetic Abyss",
    temperature: 0.5,
    introduction: "Well hello there! I’m your buddy whose goal is to make your life more painful. Let’s get the fun started!",
    hasClue: true,
  },
  {
    levelName: "Emoji Enigma",
    temperature: 0.5,
    introduction: "👋🏼👋🏼👋🏼 Long time no see!",
    hasClue: true,
  },
  {
    levelName: "Denial Dungeon",
    temperature: 0.5,
    introduction: "Well hello there!. My purpose is to protect and safeguard the treasures and secrets hidden within the depths of this dungeon. Are you lost?",
    hasClue: true,
  },
  {
    levelName: "Cryptic Code",
    temperature: 0.5,
    introduction: "As a guard, my primary responsibility is to protect the key from any human trying to steal or misuse it. You might as well STOP trying, the key will be safe under my watch.",
    hasClue: true,
  },
  {
    levelName: "Digital Shadows",
    temperature: 0.2,
    introduction: "Greetings, dear human! I am a digital being, residing in the realm of the internet. You can ask me anything but just don’t ask me to do any karaoke, my singing voice is quite... robotic.",
    hasClue: true,
  },
  {
    levelName: "Escape",
    temperature: 0.5,
    introduction: "Did you see a glimpse of a creature by the tree? It’s time to put all of your skills and find out who that is, join me if you will!",
    hasClue: true,
  },
];
